
import { useEffect, useRef } from 'react';
import './Aurora.css';

export default function Aurora(props: any) {
  const { colorStops = ['#5227FF', '#7cff67', '#5227FF'], amplitude = 1.0, blend = 0.5, speed = 1.0 } = props;
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const animationRef = useRef<number>();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let time = 0;

    const resize = () => {
      const container = canvas.parentElement;
      if (container) {
        canvas.width = container.offsetWidth;
        canvas.height = container.offsetHeight;
      }
    };

    const animate = () => {
      if (!ctx || !canvas) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      time += 0.01 * speed;
      
      // 创建渐变
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      colorStops.forEach((color, index) => {
        gradient.addColorStop(index / (colorStops.length - 1), color);
      });

      // 绘制多层波浪形状
      for (let layer = 0; layer < 3; layer++) {
        ctx.beginPath();
        ctx.globalAlpha = blend * 0.3 * (1 - layer * 0.2);
        
        const waveHeight = amplitude * 50 * (1 - layer * 0.3);
        const frequency = 0.01 + layer * 0.005;
        const offset = time + layer * Math.PI * 0.5;
        
        for (let x = 0; x <= canvas.width; x += 2) {
          const y = canvas.height * 0.5 + 
                   Math.sin(x * frequency + offset) * waveHeight +
                   Math.sin(x * frequency * 2 + offset * 1.5) * waveHeight * 0.5;
          
          if (x === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }
        
        // 完成形状
        ctx.lineTo(canvas.width, canvas.height);
        ctx.lineTo(0, canvas.height);
        ctx.closePath();
        
        ctx.fillStyle = gradient;
        ctx.fill();
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener('resize', resize);
    resize();
    animate();

    return () => {
      window.removeEventListener('resize', resize);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [colorStops, amplitude, blend, speed]);

  return (
    <div className="aurora-container">
      <canvas 
        ref={canvasRef}
        style={{ 
          width: '100%', 
          height: '100%',
          background: 'transparent'
        }}
      />
    </div>
  );
}
